// import { defineCancelApiObject } from './configs/axiosUtils';
import { callApi } from '../../apiCaller';
import { toastError } from '../../utils';

const ORDER_ENDPOINT = 'order';

export const OrderAPI = {
     applyVoucher: async (payload, cancel = false) => {
          const { id, ...restPayload } = payload;

          const endpoint = `${ORDER_ENDPOINT}/${id}/apply-voucher`;

          return await callApi(endpoint, 'PATCH', restPayload).then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               return response.data;
          });
     },

     checkGeneratedVoucherUsed: async (id, selectedProductIds, cancel = false) => {
          const endpoint = `${ORDER_ENDPOINT}/${id}/checking-voucher-use`;

          const payload = { selectedProductIds };

          return await callApi(endpoint, 'POST', payload).then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               return response.data;
          });
     },
};

// // Defining the cancel API object for CouponAPI
// const cancelApiObject = defineCancelApiObject(CouponAPI);
